import { makeStyles } from "@mui/styles";

const useOTBStyle = makeStyles((theme) => ({
  PsychometricPage: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    minHeight: "calc(100svh - 84px)",
    overflow: "hidden",
    position: "relative",
    marginBottom: -20,
    alignItems: "center",
    [theme.breakpoints.down("lg")]: {
      padding: "4% 0 20px",
    },
    [theme.breakpoints.down("md")]: {
      height: "100%",
    },
  },
  mainLayout: {
    [theme.breakpoints.down("md")]: {
      marginTop: 25,
      textAlign: "center",
    },
    "& h3": {
      fontSize: 56,
      color: "#0a0a0b",
      fontWeight: 700,
      lineHeight: "58px",
      marginBottom: 32,
      [theme.breakpoints.down("md")]: {
        fontSize: 28,
        lineHeight: "29px",
        marginBottom: 15,
      },
      [theme.breakpoints.down("xsm")]: {
        textAlign: "left",
      },
      [theme.breakpoints.down("370")]: {
        fontSize: 25,
      },
      "& span": {
        color: "var(--darkGray)",
      },
    },
    "& h4": {
      fontSize: 24,
      color: "#747787",
      fontWeight: 700,
      lineHeight: "31px",
      //   marginBottom: 32,
      [theme.breakpoints.down("md")]: {
        fontSize: 20,
        lineHeight: "29px",
        // marginBottom: 15,
      },
      [theme.breakpoints.down("xsm")]: {
        textAlign: "left",
      },
      [theme.breakpoints.down("370")]: {
        fontSize: 18,
      },
      "& span": {
        color: "var(--darkGray)",
      },
    },
    "& p": {
      fontSize: 20,
      color: "var(--gray)",
      fontWeight: 700,
      marginBottom: 30,
      lineHeight: "26px",
      maxWidth: 639,
      [theme.breakpoints.down("md")]: {
        fontSize: 14,
        margin: "0 auto 24px auto",
        lineHeight: "20px",
      },
      [theme.breakpoints.down("xsm")]: {
        textAlign: "left",
      },
      "& span": {
        color: "var(--Tertiary)",
      },
    },
    "& h5": {
      fontSize: 24,
      maxWidth: 482,
      color: "#86650A",
      fontWeight: 700,
      marginBottom: "16px",
      lineHeight: "31px",
      [theme.breakpoints.down("md")]: {
        margin: "0px auto 32px",
        fontSize: 18,
        lineHeight: "22px",
      },
      [theme.breakpoints.down("xsm")]: {
        textAlign: "left",
      },
    },
    "& > .MuiButtonBase-root": {
      [theme.breakpoints.down("md")]: {
        margin: "0 auto",
      },
    },
  },
  reportLayout: {
    width: "100%",
    padding: "20px 30px",
    minHeight: "calc(100vh - 128px)",
    borderBottom: "1px solid #ccc",
    flexDirection: "column",
    display: "flex",
    [theme.breakpoints.down("md")]: {
      marginBottom: 18,
      padding: "0 20px",
    },
    "& h2": {
      fontSize: 34,
      color: "var(--blackGray)",
      fontWeight: 700,
      lineHeight: "44px",
      paddingBottom: 16,
      [theme.breakpoints.down("md")]: {
        fontSize: 26,
        lineHeight: "29px",
        marginBottom: 24,
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: 22,
        lineHeight: "24px",
        marginBottom: 18,
      },
      "& span": {
        color: "var(--darkGray)",
      },
    },
    "& h3": {
      fontSize: 24,
      color: "#747787",
      fontWeight: 700,
      lineHeight: "31px",
      [theme.breakpoints.down("md")]: {
        fontSize: 20,
        lineHeight: "29px",
      },
      [theme.breakpoints.down("xsm")]: {
        textAlign: "left",
      },
      [theme.breakpoints.down("370")]: {
        fontSize: 18,
      },
      "& span": {
        color: "var(--darkGray)",
      },
    },
    "& h5": {
      fontSize: 16,
      maxWidth: 482,
      fontWeight: 400,
      lineHeight: "22px",
    },
    "& > .MuiButtonBase-root": {
      [theme.breakpoints.down("md")]: {
        margin: "0 auto",
      },
    },
  },
  stickyTitle: {
    position: "sticky",
    top: 128,
    background: "#f9fafc",
    zIndex: 9,
  },
  imagingLabel: {
    textOverflow: "ellipsis",
    overflow: "hidden",
  },
  pdfReportLayout: {
    width: "100%",
    padding: "0 30px",
    "& h4": {
      fontSize: 32,
      color: "var(--blackGray)",
      fontWeight: 700,
      lineHeight: "44px",
      paddingBottom: 4,
      borderBottom: "2px solid #8D6A3D",
      marginBottom: "10px",
    },
    "& h2": {
      fontSize: 28,
      color: "var(--blackGray)",
      fontWeight: 700,
      lineHeight: "44px",
      paddingBottom: 8,

      "& span": {
        color: "var(--darkGray)",
      },
    },
    "& h3": {
      fontSize: 24,
      color: "#747787",
      fontWeight: 700,
      lineHeight: "31px",
      "& span": {
        color: "var(--darkGray)",
      },
    },
    "& h5": {
      fontSize: 16,
      maxWidth: 482,
      fontWeight: 400,
      lineHeight: "22px",
    },
    "& h6": {
      fontSize: 14,
      fontWeight: 400,
      lineHeight: "16px",
    },
    // "& svg": {
    //   width: "50px",
    //   height: "25px",
    // },
    "& > .MuiButtonBase-root": {
      [theme.breakpoints.down("md")]: {
        margin: "0 auto",
      },
    },
  },
  cardTextHeading: {
    "&h3": {
      color: "#898994",
      fontSize: "24px",
      fontWeight: 500,
      lineHeight: "31.25px",
    },
  },
  reportCard: {
    padding: 20,
    background: "#FFFFFF",
    boxShadow: "0px 0px 16px 0px #00000014",
    borderRadius: "16px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    marginBottom: 10,
    flex: "auto",
    [theme.breakpoints.down("xl")]: {
      padding: 15,
    },
    [theme.breakpoints.down("1300")]: {
      padding: 14,
    },
    "& p": {
      fontSize: 24,
      fontWeight: 500,
      lineHeight: "1",
      "& span": {
        color: "var(--Tertiary)",
      },
      [theme.breakpoints.down("1300")]: {
        fontSize: 22,
      },
    },
    "& h3": {
      fontSize: 18,
      color: "#898994",
      fontWeight: 500,
      lineHeight: "31.25px",
    },
    "& .card-text": {
      color: "#202024",
    },
    "& .record": {
      fontSize: 24,
      fontWeight: 700,
      lineHeight: "40px",
      marginTop: "16px",
      "& span": {
        fontSize: 18,
        fontWeight: 400,
        lineHeight: "22px",
        color: "var(--gray)",
      },
    },
  },
  pdfReportCard: {
    padding: "16px",
    background: "#F3F3F3",
    boxShadow: "0px 0px 16px 0px #00000014",
    borderRadius: "16px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    width: "100%",
    "& p": {
      fontSize: 22,
      fontWeight: 500,
      lineHeight: "32px",
      "& span": {
        color: "var(--Tertiary)",
      },
    },
    "& h2": {
      fontSize: 20,
      fontWeight: 600,
      lineHeight: "26.25px",
    },
    "& h3": {
      fontSize: 18,
      color: "#898994",
      fontWeight: 500,
      lineHeight: "26.25px",
    },
    "& .card-text": {
      color: "#202024",
    },
    "& .record": {
      fontSize: 20,
      fontWeight: 700,
      lineHeight: "34px",
      marginTop: "16px",
      "& span": {
        fontSize: 18,
        fontWeight: 400,
        lineHeight: "22px",
        color: "var(--gray)",
      },
    },
  },
  pdfChartCard: {
    border: "1px solid #B29263",
    borderRadius: "8px",
    padding: "8px",
    backgroundColor: "#D5B98B20",
    "& p": {
      fontSize: 22,
      fontWeight: 500,
      lineHeight: "32px",
      "& span": {
        color: "var(--Tertiary)",
      },
    },
    "& h2": {
      fontSize: 24,
      fontWeight: 600,
      lineHeight: "26.25px",
    },
    "& h3": {
      fontSize: 16,
      color: "#898994",
      fontWeight: 400,
      lineHeight: "20px",
    },
    "& h6": {
      fontSize: 14,
      fontWeight: 500,
      lineHeight: "12px",
    },
  },
  PsychometricImage: {
    "& svg": {
      width: "290px",
      height: "100px",
      marginBottom: "30px",
    },
  },
  PdfPsychometricImage: {
    "& svg": {
      width: "330px",
      height: "100px",
      marginBottom: "30px",
      [theme.breakpoints.down("md")]: {
        height: 260,
      },
      [theme.breakpoints.down("sm")]: {
        height: 240,
      },
    },
  },
  goBackBtn: {
    "&.MuiButton-root": {
      background: "transparent",
      padding: 0,
      color: "var(--primary)",
      marginBottom: "24px",
      "& .MuiButton-startIcon": {
        "& svg": {
          "& path": {
            stroke: "var(--primary)",
          },
        },
      },
      "&:hover": {
        background: "transparent",
      },
    },
  },
  downloadBtn: {
    "&.MuiButtonBase-root": {
      padding: "10px 12px",
      minWidth: 230,
      [theme.breakpoints.down("sm")]: {
        padding: "9px",
      },
      "&.MuiButton-outlined": {
        border: "2px solid var(--FrontLine)",
      },
      "& .content": {
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        fontWeight: "400",
        gap: 5,
        color: "var(--FrontLine)",
      },
    },
  },
  Button: {
    "&.MuiButtonBase-root": {
      background: "linear-gradient(132.61deg, #C3A577 32.09%, #B29263 163.78%)",
      "&.MuiButton-root": {
        padding: "12px 10px",
        fontWeight: 700,
        [theme.breakpoints.up("sm")]: {
          minWidth: 180,
        },
        "& .content": {
          [theme.breakpoints.up("sm")]: {
            fontSize: 16,
          },
        },
      },
      "&:not(.MuiButton-outlined)[disabled]": {
        opacity: 0.7,
        background:
          "linear-gradient(132.61deg, #C3A577 32.09%, #B29263 163.78%)",
      },
    },
  },
  compilingLoader: {
    background: "linear-gradient(132.61deg, #C3A577 32.09%, #B29263 163.78%)",
    padding: "12px 26px",
    borderRadius: 10,
    alignItems: "center",
    color: "#fff",
    fontWeight: 600,
    fontSize: "16px",
  },
  welcomeArrowDown: {
    position: "absolute",
    left: 0,
    bottom: "25%",
    transform: "translateY(-40%)",
    rotate: "180deg",
  },
  welcomeArrowRight: {
    position: "absolute",
    right: 0,
    bottom: "-82px",
    rotate: "90deg",
    zIndex: "9999",
  },
  arrowDown: {
    position: "fixed",
    right: "35%",
    bottom: "-20%",
    transform: "translateY(-50%)",
    zIndex: 1,
    rotate: "90deg",
  },
  arrowTop: {
    position: "fixed",
    right: "30%",
    top: "-5%",
    transform: "translateY(-50%)",
    zIndex: 1,
    rotate: "270deg",
  },
  arrowRight: {
    position: "fixed",
    left: 0,
    bottom: 0,
    zIndex: "9999",
    pointerEvents: "none",
    [theme.breakpoints.down("slg")]: {
      zIndex: 1,
    },
  },
  stickyOtbHeader: {
    position: "sticky",
    top: 64,
    left: 320,
    right: 0,
    zIndex: 200,
    padding: "0 12px",
    minHeight: 64,
    display: "flex",
  },
  fixedOtbHeader: {
    backgroundColor: "#ffffff",
    borderBottom: "1px solid #ddd",
  },
  otbWrapper: {
    display: "flex",
    position: "relative",
    marginTop: -20,
    background: "#F9FAFC",
  },
  sidebarMenu: {
    paddingLeft: 0,
  },
  fixedLogo: {
    position: "fixed",
    bottom: 20,
    right: 10,
    zIndex: "-1",
    "& img": {
      maxWidth: 140,
    },
  },
  FilterOrganizationInput: {
    minWidth: "135px",
    backgroundColor: "white",
    "& .MuiSelect-select": {
      padding: "8px 32px 8px 12px",
      fontSize: 14,
    },
    "& .MuiSvgIcon-root": {
      position: "absolute",
      right: 7,
      pointerEvents: "none",
    },
  },
  reportCardHeading: {
    "&.MuiTypography-root": {
      fontSize: 22,
      fontWeight: 500,
    },
  },
  donutContainer: {
    width: 340,
    height: 340,
    backgroundColor: "var(--white)",
    borderRadius: "50%",
    overflow: "hidden",
    margin: "0 auto",
    [theme.breakpoints.down("xl")]: {
      marginTop: 20,
      marginBottom: 20,
    },
    [theme.breakpoints.down("sm")]: {
      width: 320,
      height: 320,
    },
    [theme.breakpoints.down("xts")]: {
      width: 230,
      height: 230,
    },
  },
  donut: {
    position: "relative",
    width: "100%",
    height: "100%",
    backgroundColor: "var(--white)",
    borderRadius: "50%",
    overflow: "hidden",
    transform: "rotate(45deg)",
  },
  segment: {
    position: "absolute",
    width: "49%",
    height: "49%",
    clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
    "& .MuiBox-root": {
      position: "absolute",
      width: 10,
      height: 10,
      display: "block",
      borderRadius: "100%",
      [theme.breakpoints.down("sm")]: {
        width: 6,
        height: 6,
      },
    },
  },
  inActive: {
    opacity: 0.5,
  },
  active: {
    "&:before": {
      content: "normal",
    },
  },
  segment1: {
    backgroundColor: "#e3f1f9",
    transform: "rotate(0deg)",
    right: 0,
  },
  segment2: {
    backgroundColor: "#fff7ec",
    transform: "rotate(90deg)",
    right: 0,
    bottom: 0,
  },
  segment3: {
    backgroundColor: "#f0f9f2",
    transform: "rotate(180deg)",
    left: 0,
    bottom: 0,
  },
  segment4: {
    backgroundColor: "#f2e7f5",
    transform: "rotate(270deg)",
  },
  circle: {
    width: 90,
    height: 90,
    backgroundColor: "var(--white)",
    position: "absolute",
    left: "50%",
    top: "50%",
    borderRadius: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      width: 80,
      height: 80,
    },
    "&::before": {
      content: '""',
      width: 75,
      height: 75,
      backgroundColor: "var(--white)",
      position: "absolute",
      left: "50%",
      top: "50%",
      borderRadius: "50%",
      transform: "translate(-50%, -50%)",
      filter:
        "drop-shadow(0px 5px 11px rgba(216, 202, 202, 0.1)) drop-shadow(0px 20px 20px rgba(216, 202, 202, 0.09))",
      backdropFilter: "blur(5px)",
      [theme.breakpoints.down("sm")]: {
        width: 70,
        height: 70,
      },
    },
    "& img": {
      position: "relative",
      transform: "rotate(-45deg)",
      top: "5px",
      left: "5px",
      [theme.breakpoints.down("sm")]: {
        fontSize: 26,
      },
    },
  },
  dot: {
    height: "100%",
    width: "60%",
    padding: "51px 11px 36px 45px",
    [theme.breakpoints.down("sm")]: {
      padding: "41px 5px 20px 40px",
    },
    "& > span": {
      position: "absolute",
      fontSize: 14,
      [theme.breakpoints.down("sm")]: {
        fontSize: 12,
      },
    },
  },
  dotWrapper: {
    position: "relative",
    height: "100%",
    width: "100%",
  },

  label1: {
    left: 0,
    color: "#1780c6",
    bottom: 0,
    transform: "rotate(-90deg)",
    textAlign: "center",
    fontWeight: 700,
    transformOrigin: "4% 4%",
    width: 120,
    height: 50,
    overflow: "hidden",
    WebkitLineClamp: 3,
    display: "-webkit-box",
    wordBreak: "break-word",
    WebkitBoxOrient: "vertical",
    [theme.breakpoints.down("sm")]: {
      width: 60,
      transformOrigin: "7% 6%",
    },
  },
  label2: {
    left: 0,
    bottom: 0,
    textAlign: "center",
    transformOrigin: "4% 4%",
    transform: "rotate(270deg)",
    color: "#ffb142",
    fontWeight: 700,
    width: 120,
    height: 50,
    overflow: "hidden",
    WebkitLineClamp: 3,
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    wordBreak: "break-word",
    [theme.breakpoints.down("sm")]: {
      transformOrigin: "9% 10%",
      bottom: 2,
      width: 60,
    },
  },
  label3: {
    left: 0,
    bottom: 61,
    transform: "rotate(90deg)",
    color: "#2d8f4e",
    fontWeight: 700,
    width: 120,
    height: 50,
    textAlign: "center",
    transformOrigin: "44% 0%",
    overflow: "hidden",
    WebkitLineClamp: 3,
    display: "flex",
    WebkitBoxOrient: "vertical",
    alignItems: "flex-end",
    justifyContent: "center",
    wordBreak: "break-word",
    [theme.breakpoints.down("sm")]: {
      bottom: 60,
      width: 60,
      transformOrigin: "38% 56%",
    },
  },
  label4: {
    left: 0,
    bottom: 60,
    transform: "rotate(90deg)",
    color: "#8b3f9e",
    fontWeight: 700,
    textAlign: "center",
    transformOrigin: "44% 0%",
    width: 120,
    height: 50,
    overflow: "hidden",
    WebkitLineClamp: 3,
    display: "flex",
    WebkitBoxOrient: "vertical",
    alignItems: "flex-end",
    justifyContent: "center",
    wordBreak: "break-word",
    [theme.breakpoints.down("sm")]: {
      bottom: 60,
      width: 60,
      transformOrigin: "38% 55%",
    },
  },
  loader: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(255, 255, 255, 0.7)",
    zIndex: 9999,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backdropFilter: "blur(10px)",
  },
}));

export default useOTBStyle;
